import { MonitoringUpdateRoomTypeLayer } from '../../types/monitoringUpdate'
import InputBoxValuesRoomTypeMenu from './InputBoxValuesRoomTypeMenu'

interface RowBoxValuesRoomTypeMenuProps {
  weekendIndexes: number[]
  range: 'TWO_WEEKS' | 'MONTH'
  dataRoomType: MonitoringUpdateRoomTypeLayer
  selectedRoomTypeRowMenu: string
}

export default function RowBoxValuesRoomTypeMenu({
  weekendIndexes,
  range,
  dataRoomType,
  selectedRoomTypeRowMenu
}: RowBoxValuesRoomTypeMenuProps) {
  switch (selectedRoomTypeRowMenu) {
    case 'default':
      return (
        <>
          {dataRoomType.dataForEachDate.map((data, index) => (
            <InputBoxValuesRoomTypeMenu
              key={index}
              weekendIndexes={weekendIndexes}
              index={index}
              data={{ status: data.status, time: data.time }}
              range={range}
            />
          ))}
        </>
      )
    case 'availability':
      return (
        <>
          {dataRoomType.dataForEachDate.map((data, index) => (
            <InputBoxValuesRoomTypeMenu
              key={index}
              weekendIndexes={weekendIndexes}
              index={index}
              data={data.availability}
              range={range}
            />
          ))}
        </>
      )
    case 'pooledAvailability':
      return (
        <>
          {dataRoomType.dataForEachDate.map((data, index) => (
            <InputBoxValuesRoomTypeMenu
              key={index}
              weekendIndexes={weekendIndexes}
              index={index}
              data={data.pooledAvailability!}
              range={range}
            />
          ))}
        </>
      )
    case 'totalAllocatedAvailabiliy':
      return (
        <>
          {dataRoomType.dataForEachDate.map((data, index) => (
            <InputBoxValuesRoomTypeMenu
              key={index}
              weekendIndexes={weekendIndexes}
              index={index}
              data={data.totalAllocatedAvailabiliy!}
              range={range}
            />
          ))}
        </>
      )
    default:
      return <div />
  }
}
